exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.alert-message-out {\n\tborder-bottom: solid 1px #1c869a;\n\tborder-left: solid 1px #1c869a;\n\tpadding: 0 0 3px 3px;\n}\n.alert-message {\n\tborder: solid 1px #1c869a;\n\tpadding: 0 5px 0 5px;\n\tfont-size: 13px;\n}\n.alert-message-in {\n\tborder-bottom: solid 1px gray;\n\tborder-left: solid 1px gray;\n\tpadding: 0 0 3px 3px;\n}\n.alert-message-fine {\n\tborder: solid 1px gray;\n\tpadding: 0 5px 0 5px;\n\tfont-size: 13px;\n}\n.icon-size {\n\twidth: 18px;\n\theight: 18px;\n}\n", ""]);

// exports
